(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.asideEl = this.querySelector('aside');
      this.activeText = 1;
      this.textDelay = 3000;
      this.textInterval = null;
      this.observer = null;
      this.createObserver();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.textInterval) {
        clearInterval(this.textInterval);
      }
    }

    createObserver() {
      const ctx = this;
      ctx.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (ctx.textInterval) {
          clearInterval(ctx.textInterval);
        }
        if (entry.isIntersecting) {
          ctx.textInterval = setInterval(() => {
            ctx.asideEl.classList.toggle('is-text-1', ctx.activeText === 2);
            ctx.asideEl.classList.toggle('is-text-2', ctx.activeText === 1);
            ctx.activeText = ctx.activeText === 1 ? 2 : 1;
          }, ctx.textDelay);
        } else {
          ctx.asideEl.classList.add('is-text-1');
        }
      });
      ctx.observer.observe(ctx.asideEl);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.isScrolled = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll(); // set initial state
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const y = window.pageYOffset || document.documentElement.scrollTop;

        // Hysteresis thresholds (tune these)
        const ON_AT = 48;
        const OFF_AT = 16;

        if (!this.isScrolled && y > ON_AT) this.isScrolled = true;
        else if (this.isScrolled && y < OFF_AT) this.isScrolled = false;

        document.documentElement.classList.toggle('is-scrolled', this.isScrolled);

        this.ticking = false;
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSection extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.observer = null
      this.visibilityTimeout = null
      this.createObserver()
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
      if (this.visibilityTimeout) {
        clearTimeout(this.visibilityTimeout)
      }
    }

    createObserver() {
      const ctx = this
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (ctx.visibilityTimeout) {
            clearTimeout(ctx.visibilityTimeout)
          }
          if (entry.isIntersecting) {
            ctx.visibilityTimeout = setTimeout(() => {
              entry.target.classList.add("is-visible")
            }, 250)
          } else {
            ctx.visibilityTimeout = setTimeout(() => {
              entry.target.classList.remove("is-visible")
            }, 250)
          }
        })
      }, {threshold: 0.333})
      this.observer.observe(this.querySelector('.hero'))
    }
  }

  customElements.define('hero-section', HeroSection)

  } catch(e) { console.error(e); }
})();
})();
